import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthRoutingGuard } from "./guards/auth-routing.guard";
import { HomeComponent } from "./pages/home/home.component";
import { LoginComponent } from "./pages/login/login.component";
import { MisionControlComponent } from "./pages/mision-control/mision-control.component";

const routes: Routes = [
  { path: "", component: HomeComponent },
  {
    path: "mision-control",
    component: MisionControlComponent,
    canActivate: [AuthRoutingGuard],
  },
  { path: "login", component: LoginComponent},
  { path: "**", pathMatch: "full", redirectTo: "home" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      anchorScrolling: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
